module.exports = __webpack_public_path__ + "media/images/icons/pin-994abdd3d3c8f6b1789df8ae19a8b336.svg";